import { Filter } from '@loopback/filter';
import { api } from 'api/api';
import { Area } from 'shared/model/area.model';

export const extendedApi = api
  .enhanceEndpoints({
    addTagTypes: ['areas'],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: builder => ({
      getAreas: builder.query<Area[], Filter<Area> | void>({
        query: filter => ({
          url: `/area-of-interests`,
          method: 'GET',
          params: filter
            ? {
                filter: JSON.stringify(filter),
              }
            : undefined,
        }),
        providesTags: ['areas'],
      }),
    }),
  });

export const { useGetAreasQuery } = extendedApi;
